import { useMemo } from 'react'

import { ClientListClientObject } from '@lyrahealth-inc/shared-app-logic/src/models/client/ClientListClient'

import { useClientsData } from './useClientsData'
import { ExtractRTKQueryArgs, ExtractRTKQueryOptions, RTKQueryResultType } from '../../../../data/baseApi'
import { useGetClientsQuery } from '../ltClientsApi'

type AllClientsData = (
  args?: Partial<ExtractRTKQueryArgs<typeof useGetClientsQuery>>,
  options?: ExtractRTKQueryOptions<typeof useGetClientsQuery>,
) => [
  ClientListClientObject[],
  RTKQueryResultType<typeof useGetClientsQuery>,
  RTKQueryResultType<typeof useGetClientsQuery>,
]
export const useAllClientsData: AllClientsData = (args, opts) => {
  const activeClients = useClientsData(
    {
      status: 'active',
      ...args,
    },
    opts,
  )
  const inactiveClients = useClientsData(
    {
      status: 'inactive',
      ...args,
    },
    opts,
  )

  const clients = useMemo(() => {
    let clients: ClientListClientObject[] = []
    if (activeClients.data) {
      clients = clients.concat(...activeClients.data)
    }
    if (inactiveClients.data) {
      clients = clients.concat(...inactiveClients.data)
    }
    return clients
  }, [activeClients.data, inactiveClients.data])
  return [clients, activeClients, inactiveClients]
}
